import { EditableFieldData } from "../../store/bulk-edit-store";

export interface ValidationResult {
  isValid: boolean;
  errorMessage: string | null;
}

/**
 * Validates a cell value against field-specific rules.
 * Returns { isValid, errorMessage }.
 */
export function validateCell(value: string, fieldName: string, fieldData: EditableFieldData): ValidationResult {
  // 1. Required check
  if (fieldData.required && (!value || value.trim() === "")) {
    return { isValid: false, errorMessage: "This field is required." };
  }

  // If value is empty and not required, it's valid
  if (!value || value.trim() === "") {
    return { isValid: true, errorMessage: null };
  }

  // 2. Type-specific checks
  switch (fieldData.fieldType) {
    case "numeric": {
      const cleaned = value.replace(/,/g, "");
      if (isNaN(Number(cleaned)) || !isFinite(Number(cleaned))) {
        return { isValid: false, errorMessage: "Must be a valid number." };
      }
      break;
    }
    case "dropdown": {
      if (fieldData.options && fieldData.options.length > 0 && !fieldData.options.includes(value)) {
        return { isValid: false, errorMessage: "Value not in allowed options." };
      }
      break;
    }
    case "date": {
      const parsed = new Date(value);
      if (isNaN(parsed.getTime())) {
        return { isValid: false, errorMessage: "Must be a valid date." };
      }
      break;
    }
  }

  return { isValid: true, errorMessage: null };
}
